(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counter-with-image"] && !Shopify.designMode) return;
  try {
    
  function inVisible(element) {
    var WindowTop = $(window).scrollTop();
    var WindowBottom = WindowTop + $(window).height();
    var ElementTop = element.offset().top;
    var ElementBottom = ElementTop + element.height();
    if (ElementBottom <= WindowBottom && ElementTop >= WindowTop) animate(element);
  }

  function animate(element) {
    if (!element.hasClass('ms-animated')) {
      var maxval = element.data('max');
      var html = element.html();
      element.addClass('ms-animated');
      $({
        countNum: element.html(),
      }).animate(
        {
          countNum: maxval,
        },
        {
          //duration 5 seconds
          duration: 3000,
          easing: 'linear',
          step: function () {
            element.html(Math.floor(this.countNum) + html);
          },
          complete: function () {
            element.html(this.countNum + html);
          },
        }
      );
    }
  }

  //When the document is ready
  $(function () {
    //This is triggered when the
    //user scrolls the page
    $(window).scroll(function () {
      //Checking if each items to animate are
      //visible in the viewport
      $('span[data-max]').each(function () {
        inVisible($(this));
      });
    });
  });
  // Select the <marquee> element
  var mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    speed: 5500,
    reverseDirection: true,
    ltr: true,
    loop: true,
    direction: 'vertical',
    mousewheel: false,
    touchStartPreventDefault: false,
    preventClicks: false,
    preventClicksPropagation: false,
    autoplay: {
      delay: 0,
    },
  });
  var mySwiperone = new Swiper('.swiper-container-one', {
    direction: 'vertical',
    slidesPerView: 'auto',
    loop: true,
    speed: 7500,
    reverseDirection: true,
    ltr: true,
    mousewheel: false,
    touchStartPreventDefault: false,
    preventClicks: false,
    preventClicksPropagation: false,
    autoplay: {
      delay: 0,
    },
  });
  var mySwipertwo = new Swiper('.swiper-container-two', {
    direction: 'vertical',
    slidesPerView: 'auto',
    loop: true,
    speed: 6000,
    reverseDirection: true,
    ltr: true,
    mousewheel: false,
    touchStartPreventDefault: false,
    preventClicks: false,
    preventClicksPropagation: false,
    autoplay: {
      delay: 0,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement"] && !Shopify.designMode) return;
  try {
    
  const slidesContainer = document.getElementById('two-announcement-slides-container');
  const slides = document.querySelectorAll('.two-announcement-slide');
  const prevButton = document.getElementById('two-announcement-slide-arrow-prev');
  const nextButton = document.getElementById('two-announcement-slide-arrow-next');
  const slideWidth = slides[0].offsetWidth; // Use offsetWidth to get the width of a single slide
  let currentSlide = 0;

  nextButton.addEventListener('click', () => {
    currentSlide = (currentSlide + 1) % slides.length;
    slidesContainer.scrollTo({
      left: currentSlide * slideWidth,
      behavior: 'smooth',
    });
  });

  prevButton.addEventListener('click', () => {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    slidesContainer.scrollTo({
      left: currentSlide * slideWidth,
      behavior: 'smooth',
    });
  });

  setInterval(() => {
    currentSlide = (currentSlide + 1) % slides.length;
    slidesContainer.scrollTo({
      left: currentSlide * slideWidth,
      behavior: 'smooth',
    });
  }, 4000);

  document.addEventListener('DOMContentLoaded', function () {
    var closeBtn = document.querySelector('.close-btn');
    var announcementBar = document.querySelector('.two-announcement-bar');

    if (closeBtn && announcementBar) {
      closeBtn.addEventListener('click', function () {
        announcementBar.style.display = 'none';
      });
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var closeBtn = document.querySelector('.announcement_close');
    var announcementBar = document.querySelector('.announcement_bar_section');

    if (closeBtn && announcementBar) {
      closeBtn.addEventListener('click', function () {
        announcementBar.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      document.getElementById('section-header').classList.add('scrolled');
    } else {
      document.getElementById('section-header').classList.remove('scrolled');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-started-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let currentStep = 1;

    function showStep(stepNumber) {
      document.querySelectorAll('.formStep').forEach((step) => {
        step.style.display = 'none';
      });

      document.getElementById(`step${stepNumber}`).style.display = 'block';
      updateProgressBar(stepNumber);
    }

    function nextStep() {
      const migrationField = document.querySelector(
        'input[value="<p>I’m looking to <strong>Migrate to Shopify</strong></p>"]'
      );
      const stepTwo = 2; // Define step number directly
      const stepThree = 3; // Define the step number directly
      const stepFour = 4; // Define the step number directly
      if (migrationField && migrationField.checked) {
        currentStep += 1; // Increment by 1 if migration is checked
      } else if (currentStep === stepThree) {
        currentStep += 1; // Increment by 1 if the current step is 3
      } else if (currentStep === stepFour) {
        currentStep += 1; // Increment by 1 if the current step is 4
      } else {
        currentStep += 2; // Increment by 2 otherwise
      }

      showStep(currentStep);
    }

    function prevStep() {
      const migrationField = document.querySelector(
        'input[value="<p>I’m looking to <strong>Migrate to Shopify</strong></p>"]'
      );
      const migrationChecked = migrationField && migrationField.checked;

      if (currentStep === 3 && !migrationChecked) {
        showStep(1); // Go back to the first step if on migration step and migration is not checked
        currentStep = 1;
      } else {
        showStep(currentStep - 1);
        currentStep -= 1;
      }
    }

    function submitForm() {
      // You can add your form submission logic here
      console.log('Form submitted successfully!');

      // Submit the form
      // document.getElementById('ContactForm').submit();

      // Delay moving to the next step by 2 seconds
      setTimeout(function () {
        nextStep();
      }, 1000);
    }

    function updateProgressBar(step) {
      const progressBar = document.getElementById('progressBar');
      const progressIndicator = progressBar.querySelector('span');
      const stepWidth = (step - 1) * 25 + '%';
      progressIndicator.style.width = stepWidth;
    }

    // Show the first step initially
    showStep(currentStep);

    // Attach event listener to Next button for step1
    document.querySelectorAll('.nextButton')[0].addEventListener('click', function () {
      var radioButtonSelected = false;
      var radioButtons = document.querySelectorAll('input[name="contact[migration]"]');
      radioButtons.forEach(function (radioButton) {
        if (radioButton.checked) {
          radioButtonSelected = true;
        }
      });
      if (!radioButtonSelected) {
        document.querySelector('.error-message').style.display = 'block';
      } else {
        document.querySelector('.error-message').style.display = 'none';
        nextStep();
      }
    });

    // Attach event listener to Next button for step2
    document.querySelectorAll('.nextButton')[1].addEventListener('click', function () {
      var radioButtonSelected = false;
      var radioButtons = document.querySelectorAll('input[name="contact[project_platform]"]');
      radioButtons.forEach(function (radioButton) {
        if (radioButton.checked) {
          radioButtonSelected = true;
        }
      });
      console.log('radioButtonSelected:', radioButtonSelected); // Check the value of radioButtonSelected
      if (!radioButtonSelected) {
        console.log('Error message should be displayed.'); // Check if this message appears in the console
        document.querySelector('.error-message-1').style.display = 'block';
      } else {
        console.log('Error message should be hidden.'); // Check if this message appears in the console
        document.querySelector('.error-message-1').style.display = 'none';
        nextStep();
      }
    });

    // Attach event listener to Next button for step3
    document.querySelectorAll('.nextButton')[2].addEventListener('click', function () {
      var radioButtonSelected = false;
      var radioButtons = document.querySelectorAll('input[name="contact[project_revenue]"]');
      radioButtons.forEach(function (radioButton) {
        if (radioButton.checked) {
          radioButtonSelected = true;
        }
      });
      console.log('radioButtonSelected:', radioButtonSelected); // Check the value of radioButtonSelected
      if (!radioButtonSelected) {
        console.log('Error message should be displayed.'); // Check if this message appears in the console
        document.querySelector('.error-message-2').style.display = 'block';
      } else {
        console.log('Error message should be hidden.'); // Check if this message appears in the console
        document.querySelector('.error-message-2').style.display = 'none';
        nextStep();
      }
    });

    // Attach event listener to Next button for step 4
    document.querySelectorAll('.nextButton')[3].addEventListener('click', function () {
      var radioButtonSelected = false;
      var radioButtons = document.querySelectorAll('input[name="contact[project_buget]"]');
      radioButtons.forEach(function (radioButton) {
        if (radioButton.checked) {
          radioButtonSelected = true;
        }
      });
      console.log('radioButtonSelected:', radioButtonSelected); // Check the value of radioButtonSelected
      if (!radioButtonSelected) {
        console.log('Error message should be displayed.'); // Check if this message appears in the console
        document.querySelector('.error-message-3').style.display = 'block';
      } else {
        console.log('Error message should be hidden.'); // Check if this message appears in the console
        document.querySelector('.error-message-3').style.display = 'none';
        nextStep();
        // Call nextStep function or perform next step logic here
      }
    });

    // Apply custom css when label is selected

    document.querySelectorAll('.block__get-started-form-option-input').forEach((input) => {
      input.addEventListener('change', function () {
        // Remove the 'selected-option' class from all options and reset background color
        document.querySelectorAll('.block__get-started-form-option').forEach((option) => {
          option.classList.remove('selected-option');
          const detailsDiv = option.querySelector('.block__get-started-form-option-details');
          if (detailsDiv) {
            detailsDiv.style.backgroundColor = '#ffffff';
          }
        });

        // Add the 'selected-option' class to the parent of the checked radio button
        if (this.checked) {
          const option = this.closest('.block__get-started-form-option');
          if (option) {
            option.classList.add('selected-option');

            // Add background color to the details div
            const detailsDiv = option.querySelector('.block__get-started-form-option-details');
            if (detailsDiv) {
              detailsDiv.style.backgroundColor = '#f1f8f9';
            }
          }
        }
      });
    });

    // Attach event listener to prev buttons
    document.querySelectorAll('.prevButton').forEach((button) => {
      button.addEventListener('click', prevStep);
    });

    // Attach event listener to Submit button
    document.getElementById('submitBtn').addEventListener('click', submitForm);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-slider"] && !Shopify.designMode) return;
  try {
    
  AOS.init();
  document.querySelector('#myBtn').addEventListener('click', function () {
    const animatedElements = document.querySelectorAll('.aos-init');
    animatedElements.forEach((element) => {
      element.classList.remove('aos-animate');
    });
  });
  document.querySelector('#myBtn').addEventListener('click', function () {
    const animatedElements = document.querySelectorAll('.aos-init');
    setTimeout(function () {
      animatedElements.forEach((element) => {
        element.classList.add('aos-animate');
      });
    }, 600);
  });

  document.querySelector('#myBtnone').addEventListener('click', function () {
    const animatedElements = document.querySelectorAll('.aos-init');
    animatedElements.forEach((element) => {
      element.classList.remove('aos-animate');
    });
  });
  document.querySelector('#myBtnone').addEventListener('click', function () {
    const animatedElements = document.querySelectorAll('.aos-init');
    setTimeout(function () {
      animatedElements.forEach((element) => {
        element.classList.add('aos-animate');
      });
    }, 600);
  });

  const wrapper = document.querySelector('.wrapper');
  const carousel = document.querySelector('.carousel');
  const firstCardWidth = carousel.querySelector('.card').offsetWidth;
  const carouselChildrens = [...carousel.children];

  let isDragging = false,
    isAutoPlay = false,
    startX,
    startScrollLeft,
    timeoutId;

  let cardPerView = Math.round(carousel.offsetWidth / firstCardWidth);

  carouselChildrens
    .slice(-cardPerView)
    .reverse()
    .forEach((card) => {
      carousel.insertAdjacentHTML('afterbegin', card.outerHTML);
    });

  carouselChildrens.slice(0, cardPerView).forEach((card) => {
    carousel.insertAdjacentHTML('beforeend', card.outerHTML);
  });
  const arrowButtonClick = (direction) => {
    clearTimeout(timeoutId);

    const scrollDistance = direction === 'left' ? -firstCardWidth : firstCardWidth;

    carousel.scrollLeft += scrollDistance;

    autoPlay();
  };
  carousel.classList.add('no-transition');
  carousel.scrollLeft = carousel.offsetWidth;
  carousel.classList.remove('no-transition');
  const dragStart = (e) => {
    isDragging = true;
    carousel.classList.add('dragging');
    startX = e.pageX;
    startScrollLeft = carousel.scrollLeft;
  };

  const dragging = (e) => {
    if (!isDragging) return;

    const dragDistance = e.pageX - startX;

    const maxScrollDistance = firstCardWidth;

    const clampedDragDistance = Math.max(-maxScrollDistance, Math.min(maxScrollDistance, dragDistance));

    carousel.scrollLeft = startScrollLeft - clampedDragDistance;
  };

  const dragStop = () => {
    isDragging = false;
    carousel.classList.remove('dragging');
  };

  const infiniteScroll = () => {
    if (carousel.scrollLeft === 0) {
      carousel.classList.add('no-transition');
      carousel.scrollLeft = carousel.scrollWidth - 2 * carousel.offsetWidth;
      carousel.classList.remove('no-transition');
    }
    // If the carousel is at the end, scroll to the beginning
    else if (Math.ceil(carousel.scrollLeft) === carousel.scrollWidth - carousel.offsetWidth) {
      carousel.classList.add('no-transition');
      carousel.scrollLeft = carousel.offsetWidth;
      carousel.classList.remove('no-transition');
    }

    // Clear existing timeout & start autoplay if mouse is not hovering over carousel
    clearTimeout(timeoutId);
    if (!wrapper.matches(':hover')) autoPlay();
  };

  const autoPlay = () => {
    if (window.innerWidth < 1140 || !isAutoPlay) return;
    timeoutId = setTimeout(() => (carousel.scrollLeft += firstCardWidth), 2500);
  };
  autoPlay();

  carousel.addEventListener('mousedown', dragStart);
  carousel.addEventListener('mousemove', dragging);
  document.addEventListener('mouseup', dragStop);
  carousel.addEventListener('scroll', infiniteScroll);
  wrapper.addEventListener('mouseenter', () => clearTimeout(timeoutId));
  wrapper.addEventListener('mouseleave', autoPlay);
  document.getElementsByClassName('left-arrow')[0].addEventListener('click', () => arrowButtonClick('left'));
  document.getElementsByClassName('right-arrow')[0].addEventListener('click', () => arrowButtonClick('right'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-direction"] && !Shopify.designMode) return;
  try {
    
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
  }
  function addAnimation() {
      const scrollers = document.querySelectorAll(".logos-left");
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".logos-left-direction"); // Corrected class name
      const scrollerContent = Array.from(scrollerInner.children);
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    addAnimation();
  }

  function addAnimation() {
    const scrollers = document.querySelectorAll('.logos');
    scrollers.forEach((scroller) => {
      scroller.setAttribute('data-animated', true);
      const scrollerInner = scroller.querySelector('.logos-slide'); // Corrected class name
      const scrollerContent = Array.from(scrollerInner.children);
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute('aria-hidden', true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["migrate-form-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    let currentStep = 1;

    function showStep(steNumber) {
        document.querySelectorAll('.formStep').forEach(ste => {
            ste.style.display = 'none';
        });

        document.getElementById(`ste${steNumber}`).style.display = 'block';
        updateProgressBar(steNumber);
    }

    function nextStep() {
        const migrationField = document.querySelector('input[name="contact[migration]"]');
        const steThree = 3; // Define the ste number directly
        const steFour = 4; // Define the ste number directly
        if (migrationField && migrationField.checked) {
            currentStep += 1; // Increment by 1 if migration is checked
        } 
        else if(currentStep === steThree) {
            currentStep += 1; // Increment by 1 if the current ste is 3
        } 
        else if(currentStep === steFour) {
            currentStep += 1; // Increment by 1 if the current ste is 3
        }else {
            currentStep += 1; // Increment by 2 otherwise
        }
        
        showStep(currentStep);
    }

    function skipStep(next) {
        showStep(next);
        currentStep = next;
    }

    function submitForm() {
        // You can add your form submission logic here
        console.log('Form submitted successfully!');

        // Delay moving to the next ste by 2 seconds
        setTimeout(function () {
            nextStep();
        }, 1000);
    }

    function updateProgressBar(ste) {
        const progressB = document.getElementById('progress');
        const progressIndicator = progressB.querySelector('span');
        const steWidth =60 + (ste - 1) * 20 + '%';
        progressIndicator.style.width = steWidth;
    }

    // Show the first ste initially
    showStep(currentStep);

    // Attach event listener to Next button
    document.querySelectorAll('.nextButton').forEach(button => {
        button.addEventListener('click', nextStep);
    });

    // Attach event listener to Skip buttons
    document.querySelectorAll('.skipButton').forEach(button => {
        button.addEventListener('click', function () {
            skipStep(currentStep - 1);
        });
    });

    // Attach event listener to Submit button
    document.getElementById('submitBtn').addEventListener('click', submitForm);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var slideImages = document.querySelectorAll('.slide'),
      dirRight = document.getElementById('dir-control-right'),
      dirLeft = document.getElementById('dir-control-left'),
      current = 0;
    function jsActive() {
      for (var i = 0; i < slideImages.length; i++) {
        slideImages[i].classList.add('slider-active');
      }
    }
    function reset() {
      for (var i = 0; i < slideImages.length; i++) {
        slideImages[i].classList.remove('slide-is-active');
      }
    }
    function startSlide() {
      reset();
      slideImages[0].classList.add('slide-is-active');
      setTimeout(function () {
        for (var i = 0; i < slideImages.length; i++) {
          slideImages[i].classList.add('slide-transition');
        }
      }, 1000);
    }

    //slide lft
    function slideLeft() {
      reset();
      slideImages[current - 1].classList.add('slide-is-active');
      current--;
    }
    function slideRight() {
      reset();
      slideImages[current + 1].classList.add('slide-is-active');
      current++;
    }

    dirLeft.addEventListener('click', function () {
      if (current === 0) {
        current = slideImages.length;
      }
      slideLeft();
    });

    dirRight.addEventListener('click', function () {
      if (current === slideImages.length - 1) {
        current = -1;
      }
      slideRight();
    });
    //apply styling
    jsActive();
    startSlide();
  });

  } catch(e) { console.error(e); }
})();
})();
